import React from 'react'
import type { ContentBlock as ContentBlockProps } from '@/payload-types'
import { ContentBlock as ContentComponent } from '@/components/ContentBlock'

export const ContentBlock: React.FC<ContentBlockProps> = (props) => {
  // Transform columns to handle null values
  const transformedColumns = props.columns?.map(column => ({
    ...column,
    size: column.size || undefined,
    enableLink: column.enableLink || undefined,
  }))

  return (
    <ContentComponent columns={transformedColumns} />
  )
}
